import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type TInboundPlacementService = "Optimized" | "Partial" | "Minimal";

export interface IFeeSettingsState {
  inboundPlacementFeeType: TInboundPlacementService;
  storageMonth: number;
  prepFee: number | null;
  miscFee: number | null;
  miscFeePercentage: number | null;
  vat: number | null;
  vatPercentage: number | null;
}

export const initialFeeSettingsState: IFeeSettingsState = {
  inboundPlacementFeeType: "Optimized",
  storageMonth: 0,
  prepFee: null,
  miscFee: null,
  miscFeePercentage: null,
  vat: null,
  vatPercentage: null,
};

export const feeSettingsSlice = createSlice({
  name: "feeSettings",
  initialState: { ...initialFeeSettingsState },
  reducers: {
    setFeeSettings: (state, action: PayloadAction<IFeeSettingsState>) => {
      return { ...action.payload };
    },
    resetFeeSettings: (state) => {
      return { ...initialFeeSettingsState };
    },
  },
});

export const { setFeeSettings, resetFeeSettings } = feeSettingsSlice.actions;

export default feeSettingsSlice.reducer;
